import { declareRoute } from "utilities/routes/route.utility";

export const apiDocsRoute = declareRoute("/apidocs");

/** TEMPORARY test page for the Field Notes audio upload. See src/fieldNotesTester/FieldNotesTester.tsx. */
export const fieldNotesTesterRoute = declareRoute("/FieldNotes");
